<template>
  <div>
    <div style="height: 459px">
      <img style="width: 100%;height: 100%; object-fit: cover;" :src="`${ossPath}/pages/introduce/plantformIntroduce.gif`" alt="">
    </div>
    <div class="about-hdp" :style="`background: url(${ossPath}/pages/introduce/about-hdp-bg.png) no-repeat; background-size: 100% 100%`">
      <div>
        <lineTitle title="关于货代拼" titleTip="全球专线供应链服务平台" />
      </div>
      <div class="about-content">
        <p class="about-info">
          <span class="main-text">货代拼</span>
          全球专线供应链服务平台,是国内首创的货代行业的产业互联网SB2B模式，是全球专线联盟旗下的航迅物流科技有限公司借助互联网技术打造的物流业务交互平台,把优选的各国专线庄家汇集一起链接到物流平台，同时结合国内的仓链，为卖货货代提供“一键全球”门到门的020(ONLINETOOFFLINE)物流产品。货代只用专心卖货,产品、运营、资金都交给平台。
        </p>
        <div style="width: 600px; border-radius: 20px; overflow: hidden">
          <video-box :poster="`${ossPath}/pages/introduce/video-poster.png`" />
        </div>
      </div>
    </div>

    <div class="modle-wrap">
      <div>
        <lineTitle title="货代拼商业模式" titleTip="首创跨国物流产业互联网SB2B模式" />
      </div>
      <div style="margin-top: 76px; text-align: center">
        <img :src="`${ossPath}/pages/introduce/modle-img.png`" style="max-width: 100%" alt="">
      </div>
    </div>

    <div :style="`padding: 45px 0; background: url(${ossPath}/pages/introduce/power-bg.png) no-repeat; background-size: 100% 100%;`">
      <div>
        <lineTitle titleTip="链接货代与全球各专线" white-bar>
          <span slot="title" style="color: #FFF; font-size: 32px; vertical-align: middle">
            货代拼
            <span style="color: #FFF; font-size: 50px">双向</span>
            赋能
          </span>
        </lineTitle>
      </div>
    </div>

  <div class="power-main">
    <img :src="`${ossPath}/pages/introduce/power1.png`" alt="">
    <img :src="`${ossPath}/pages/introduce/power2.png`" alt="">
  </div>

    <div style="padding: 50px 0; padding-bottom: 145px; background: linear-gradient(180deg, #FFF6F2 0%, #FFFFFF 100%);">
      <div>
        <lineTitle title="服务流程" titleTip="全球便捷比价  一键到门服务" />
      </div>
      <div style="margin-top: 40px; text-align: center">
        <img :src="`${ossPath}/pages/introduce/service-step.png`" style="max-width: 100%" alt="">
      </div>
    </div>

    <div style="padding: 50px 0" :style="`background: url(${ossPath}/pages/introduce/global-bg.png) no-repeat; background-size: 100% 100%;`">
      <div>
        <lineTitle titleTip="专线集结 联通世界">
          <span slot="title">
            <img style="vertical-align: middle" :src="`${ossPath}/pages/introduce/icon-global.png`" alt="">
            全球专线联盟
          </span>
        </lineTitle>
      </div>
      <div style="margin-top: 20px;">
        <p style="width: 1200px; margin: 0 auto;font-size: 16px; color: #141414;">
          <span style="font-size: 22px; font-weight: 700; color: #0B57A6;">全球专线联盟</span>
          成立于2019年12月31日，深耕跨境物流领域近3年，是地方性、行业性、非营利性的社会组织，全球专线联盟致力于为专线物流行业营造公平竞争的良性氛围，加强协会与企业间的相互合作、疏通跨境产业链，促进传统物流转型升级。协助政府等机构了解行业最新相关信息，积极探索创新专线物流发展模式，发挥行业引领作用，制定行业标准，推动产业经济增长步伐，营造统一开放、竞争有序的专线物流市场环境，全球专线联盟作为全球最专业的专线物流发展促进组织，为会员提供最专业、最权威的资源、人才、资讯、会展、产品、服务等一站式的解决方案。
        </p>
        <!-- <div style="margin-top: 50px; text-align: center">
          <img :src="`${ossPath}/pages/introduce/global-line.png`" style="max-width: 100%" alt="">
        </div> -->
        <div class="golobal-line-intro">
          <div>
            <img class="golobal-line-intro__bg" :src="`${ossPath}/pages/introduce/golobal-line-intro-bg.png`" alt="">
            <div class="intro-item">
              <img class="sym-ico" :src="`${ossPath}/pages/introduce/sym-ico.png`" alt="">
              <p>帮助专线提高数字化</p>
              <p>的运输体验升级</p>
            </div>
            <div class="intro-item">
              <img class="sym-ico" :src="`${ossPath}/pages/introduce/sym-ico.png`" alt="">
              <p>帮助专线带来货量的增长，</p>
              <p>提高销售额</p>
            </div>
            <div class="intro-item">
              <img class="sym-ico" :src="`${ossPath}/pages/introduce/sym-ico.png`" alt="">
              <p>加强各专线的交流合作，</p>
              <p>发挥各专项优势</p>
            </div>
            <div class="intro-item">
              <img class="sym-ico" :src="`${ossPath}/pages/introduce/sym-ico.png`" alt="">
              <p>帮助专线提高门到门的物流</p>
              <p>网络能力</p>
            </div>
            <div class="intro-item">
              <img class="sym-ico" :src="`${ossPath}/pages/introduce/sym-ico.png`" alt="">
              <p>优秀企业赋能，帮助各专线获</p>
              <p>得全球化的视角、思考和链接</p>
            </div>
            <div class="intro-item">
              <img class="sym-ico" :src="`${ossPath}/pages/introduce/sym-ico.png`" alt="">
              <p>得全球化的视角、思考和链接</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-actions-wrap">
      <div style="font-size: 0; text-align: center">
        <el-popover
          placement="top"
          title=""
          width=""
          trigger="click"
          popper-class="pop-center"
          content="">
          <div class="service-box">
            <p class="title">联系我们</p>
            <img :src="`${ossPath}/pages/introduce/global-service.png`" alt="">
            <p>请扫描并添加我们顾问，为您提供全力支持</p>
          </div>
           <div slot="reference" class="action-btn plain" @click>联系我们</div>
        </el-popover>
        <el-popover
          placement="top"
          title=""
          width=""
          trigger="click"
          popper-class="pop-center"
          content="">
          <div class="service-box">
            <p class="title">联系我们</p>
            <img style="" :src="`${ossPath}/pages/introduce/global-service.png`" alt="">
            <p>请扫描并添加我们顾问，为您提供全力支持</p>
          </div>
           <div slot="reference" class="action-btn" @click>加入联盟</div>
        </el-popover>
        <!-- <div class="action-btn">加入联盟</div> -->
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="visible"
      :modal="false"
      :show-close="false"
      :lock-scroll="true"
      width="400px"
      center>
      <div>

      </div>
      <span slot="footer" class=""></span>
    </el-dialog>


  </div>
</template>

<script>
import VideoBox from "@common/videoBox";
import lineTitle from "./components/lineTitle";
export default {
  name: "introduce",
  components: {
    VideoBox,
    lineTitle
  },
  data() {
    return {
      visible: false
    }
  },
  mounted() {
    this.$store.commit("changeactive", 3)
    if(this.$refs.topMessage) setTimeout(()=>{
      this.$refs.topMessage.enterPage();
    },0);
  }
}
</script>

<style lang="scss" scoped>
  .about-hdp {
    padding-top: 50px;
    padding-bottom: 85px;
    .about-content {
      margin: 0 auto;
      margin-top: 63px;
      display: flex;
      align-items: center;
      width: 1200px;
      .about-info {
        margin-right: 100px;
        width: 500px;
        height: 240px;
        font-size: 22px;
        font-weight: 400;
        color: #141414;
        line-height: 30px;
        .main-text {
          line-height: 40px;
          color: #FF4D01;
          font-size: 28px;
          font-weight: 700;
        }
      }
    }
  }
  .modle-wrap {
    padding: 50px 0 150px;
    background: linear-gradient(180deg, #FFF6F2 0%, #FFFFFF 100%);
  }
  .power-main {
    margin: 0 auto;
    width: 1200px;
    padding-top: 70px;
    padding-bottom: 80px;
    display: flex;
    justify-content: space-between;
    img {
      max-width: calc(50% - 42px);
    }
  }
  .bottom-actions-wrap {
    background: #FFFFFF;
    padding: 40px;
    .action-btn {
      display: inline-block;
      width: 262px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      color: #FFFFFF;
      background: #FF4D01;
      font-size: 22px;
      font-weight: 600;
      border-radius: 6px;
      cursor: pointer;
      &.plain {
        margin-right: 120px;
        background: #FFFFFF;
        color: #FF4D01;
        border: 1px solid #FF4D01;
      }
    }
  }
  .service-box {
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    color: #141414;
    line-height: 22px;
    img {
      margin: 24px 0;
      width: 162px;
      height: 162px;
    }
    .title {
      font-size: 20px;
      font-weight: 600;
      line-height: 28px;
    }
  }
  .golobal-line-intro {
    margin: 0 auto;
    margin-top: 50px;
    position: relative;
    width: 488px;
    &__bg {
      width: 488px;
    }
    .intro-item {
      position: absolute;
      padding: 27px 0 12px 30px;
      width: 250px;
      height: 45px;
      line-height: 22px;
      background: #FFFFFF;
      color: #141414;
      font-size: 16px;
      box-shadow: 0px 0px 20px 0px rgba(255,77,1,0.1);
      border-bottom: 6px solid #FFFFFF;
      border-radius: 8px;
      transition: all .3s ease-in;
      .sym-ico {
        position: absolute;
        left: 25px;
        top: -22px
      }
      &:hover {
        border-bottom: 6px solid #FF4D01;
      }
      &:nth-of-type(1) {
        left: -170px;
        top: 30px
      }
      &:nth-of-type(2) {
        left: -210px;
        top: 190px
      }
      &:nth-of-type(3) {
        left: -170px;
        top: 344px;
      }
      &:nth-of-type(4) {
        right: -170px;
        top: 30px

      }
      &:nth-of-type(5) {
        right: -210px;
        top: 190px
      }
      &:nth-of-type(6) {
        right: -170px;
        top: 344px;
      }
    }
  }
</style>
<style>
  .el-popper.pop-center {
    margin-bottom: 40px;
    left: calc(50% - 180px) !important;
    padding: 15px !important;
    width: 329px;
    height: 280px;
    background: #FFFFFF;
    box-shadow: 0px 0px 20px 0px rgba(255,77,1,0.1);
    border-radius: 12px !important;
  }
  .el-popper.pop-center .popper__arrow {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/introduce.vue